<template>
  <div class="importMarker">
    <el-dialog
      class="customDialog"
      title="数据导入"
      :visible.sync="isShow"
      :close-on-click-modal = 'false'
      @close="onClose"
      :showClose="!!layerInfoData.layerId"
      :close-on-press-escape = 'false'
    >
      <div slot="title">
        <span class="title">数据导入</span>
      </div>
      <el-form :inline="true" :rules="rules" :model="gisHeader" ref="gisHeader" class="table-header">
        <el-row>
          <el-col :lg="{span: '8'}">
            <el-form-item label="设备ID：" prop="deviceId">
              <el-select v-model="gisHeader.deviceId" placeholder="请选择设备ID" @change="onHeaderChange" :disabled="!!layerInfoData.layerId">
                <el-option v-for="item in importData.tablesData.dataHeader" :label="item.name" :value="item.id" :key="item.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :lg="{span: '8'}">
            <el-form-item label="标注名称：" prop="namePropertyId">
              <el-select v-model="gisHeader.namePropertyId" placeholder="请选择标注名称" @change="onHeaderChange" :disabled="!!layerInfoData.layerId">
                <el-option v-for="item in importData.tablesData.dataHeader" :label="item.name" :value="item.id" :key="item.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :lg="{span: '8'}">
            <el-form-item label="坐标系：" prop="coordinatesType">
              <el-select v-model="gisHeader.coordinatesType" placeholder="请选择" :clearabletableProperties="false" @change="changeCoordinateType" :disabled="!!layerInfoData.layerId">
                <el-option v-for="item in CoordinateSystems2" :label="item.name" :value="item.value" :key="item.value"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :lg="{span: '8'}">
            <el-form-item label="经度：" prop="lonHeader">
              <el-select v-model="gisHeader.lonHeader" placeholder="请选择" :clearabletableProperties="false" @change="(key)=>{changeGisHeader(key, 'longitude')}" :disabled="!!layerInfoData.layerId" clearable>
                <div v-for="item in importData.tablesData.dataHeader" :key="item.id">
                  <el-option :label="item.name" :value="item.id" :disabled="isDisabled(item)"></el-option>
                </div>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :lg="{span: '8'}">
            <el-form-item label="纬度：" prop="latHeader">
              <el-select v-model="gisHeader.latHeader" placeholder="请选择" :clearabletableProperties="false" @change="(key)=>{changeGisHeader(key, 'latitude')}" :disabled="!!layerInfoData.layerId" clearable>
                <div v-for="item in importData.tablesData.dataHeader" :key="item.id">
                  <el-option :label="item.name" :value="item.id" :disabled="isDisabled(item)"></el-option>
                </div>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :lg="{span: '8'}">
            <el-form-item label="高度：" prop="heightHeader">
              <el-select v-model="gisHeader.heightHeader" placeholder="请选择" :clearabletableProperties="false" @change="(key)=>{changeGisHeader(key, 'height')}" :disabled="!!layerInfoData.layerId" clearable>
                <div v-for="item in importData.tablesData.dataHeader" :key="item.id">
                  <el-option :label="item.name" :value="item.id" :disabled="isDisabled(item)"></el-option>
                </div>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div class="table-box">
        <el-table
          ref="multipleTable"
          stripe
          :data="tableShowData"
          style="width: 100%"
          height="6.87rem"
          v-loading.fullscreen.lock="tableLoading"
          element-loading-background="rgba(0, 0, 0, 0.5)"
        >
          <!-- <el-table-column type="selection" width="50" :selectable="canSelect">
          </el-table-column> -->
          <el-table-column :width="55*zoomFactor">
            <template slot="header" slot-scope="{}">
              <el-checkbox v-model="isSelectedAll" :indeterminate="isIndeterminate" @change="onSelectAllChange"></el-checkbox>
              <!-- <el-checkbox-group v-model="checkAllState"></el-checkbox-group> -->
            </template>
            <template slot-scope="scope">
              <transition name="come">
                <el-checkbox v-model="selectedIds[scope.row.uniqueId]" :disabled="!canSelect(scope.row)" @change="(isSelected)=>{onTableSelectItem(scope.row,isSelected)}"></el-checkbox>
              </transition>
            </template>
          </el-table-column>
          <el-table-column label="序号" :width="importData.tablesData.dataHeader.length>0?50*zoomFactor:'auto'">
            <template slot-scope="scope">
              <span class="num">{{(tablePageNumber-1)*tablePageSize + scope.$index+1}}</span>
            </template>
          </el-table-column>
          <el-table-column show-overflow-tooltip  v-for="item in importData.tablesData.dataHeader" :key="item.id" :prop="item.id.toString()" :width="importData.tablesData.dataHeader.length.length>7?203*zoomFactor:'auto'">
            <template slot="header" slot-scope="{}">
              <span>{{item.name}}</span>
            </template>
          </el-table-column>
          <template slot="empty">
            <Empty></Empty>
          </template>
        </el-table>
      </div>
      <!-- <div style="height:6.8rem" v-show="gisHeader.tableProperties<=0">
        <Empty style="transform: translateY(50%)"></Empty>
      </div> -->
      <span slot="footer" class="dialog-footer">
        <div class="bottom-left">
          <span class="title">已选择</span><span class="value">{{selectedData.length}}</span><span  class="title">项，共</span><span class="value">{{importData.tablesData.dataList.length}}</span><span class="title">条</span>
        </div>
        <el-button type="default" :loading="loading" @click="onClose">取消</el-button>
        <el-button type="primary" :loading="loading" @click="onSubmit">提交</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import GeoJSON from 'geojson'
import { addDeviceMarkerBatch } from '@/api/marker'
import coordtransform from 'coordtransform'
import { CoordinateSystems2, MarkerAttributeType } from '@/configs/constants.js'

export default {
  name: 'TableDataSelect',
  props: {
    importData: {
      type: Object,
      default: () => {
        return {
          layerId: 0,
          tablesData: {
            dataHeader: [],
            dataList: []
          }
        }
      }
    }
  },
  components: { },
  data () {
    return {
      isShow: true,
      loading: false,
      // 表格加载中
      tableLoading: false,
      // 图层数据
      layerInfoData: {
        layerId: undefined
      },
      // 图层属性
      layerData: undefined,
      // 表格所有数据
      tablesData: [],
      // 表格显示的数据
      tableShowData: [],
      // 表格头
      tableHeader: [],
      // 选中数据
      selectedData: [],
      // 标注列表
      markerList: [],
      // 图层id
      layerId: undefined,
      // 表单id
      tableId: undefined,
      gisHeader: {
        lonHeader: undefined,
        latHeader: undefined,
        namePropertyId: undefined,
        deviceId: undefined,
        coordinatesType: 'WSG84',
        tableProperties: []
      },
      rules: {
        deviceId: [
          { required: true, message: '请选择设备ID字段', trigger: 'change' }
        ],
        namePropertyId: [
          { required: true, message: '请选择标注名称字段', trigger: 'change' }
        ],
        coordinatesType: [
          { required: true, message: '请选择坐标系', trigger: 'change' }
        ],
        lonHeader: [
          { required: true, message: '请选择经度', trigger: 'change' }
        ],
        latHeader: [
          { required: true, message: '请选择纬度', trigger: 'change' }
        ]
      },
      // 选中表单列表
      // tableSelected: [],
      // 表格分页数量
      tablePageNumber: 1,
      tablePageSize: 50,
      // 最大能选取数量
      maxCanSelect: 0,
      // 选中ids
      selectedIds: {},
      // 是否选中所有
      isSelectedAll: true,
      // 是否部分选中
      isIndeterminate: false,
      coordType: 'WGS84',

      CoordinateSystems2,
      MarkerAttributeType
    }
  },
  watch: {
    importData (val) {
      if (!val) {
        return
      }
      this.maxPageNumber = Math.ceil(val.tablesData.dataList.length / this.tablePageSize)
      this.tablePageNumber = 1
      this.loadTablePage(this.tablePageNumber, this.tablePageNumber + 1)
      this.tableLoading = false
    }
  },
  mounted () {
    this.tableLoading = true
    this.addTableEvent()
  },
  methods: {
    async doLayout (table) {
      await this.$nextTick()
      table.syncPostion()
    },
    // show (data) {
    //   this.isCreate = !data.layerId
    //   this.layerInfoData = data
    //   this.tableId = data.tableId
    //   this.isShow = true
    //   this.addTableEvent()
    //   this.loadData()
    // },
    changeCoordinateType (item) {
      if (this.gisHeader.coordinatesType === 'NONE') {
        this.gisHeader.lonHeader = undefined
        this.gisHeader.latHeader = undefined
        this.gisHeader.heightHeader = undefined
        this.gisHeader.tableProperties.forEach(property => {
          if (property.tag) {
            property.tag = undefined
          }
        })
      } else {

      }
      // this.onSelectAllChange(!!this.gisHeader.namePropertyId && this.layerInfoData.type === 'POINT' && this.gisHeader.coordinatesType !== 'NONE')
      this.onSelectAllChange(true)
    },
    // 修改gis头信息
    changeGisHeader (propertyId, type) {
      console.log('--------', propertyId, type)
      if (type === 'longitude') {
        this.gisHeader.lonHeader = propertyId
        this.gisHeader.tableProperties.forEach(property => {
          if (property.tag === 'LONGITUDE') {
            property.tag = undefined
          }
          if (property.id === propertyId) {
            property.tag = 'LONGITUDE'
            property.type = 'NUMBER'
          }
        })
      } else if (type === 'latitude') {
        this.gisHeader.latHeader = propertyId
        this.gisHeader.tableProperties.forEach(property => {
          if (property.tag === 'LATITUDE') {
            property.tag = undefined
          }
          if (property.id === propertyId) {
            property.tag = 'LATITUDE'
            property.type = 'NUMBER'
          }
        })
      } else if (type === 'height') {
        this.gisHeader.heightHeader = propertyId
        this.gisHeader.tableProperties.forEach(property => {
          if (property.tag === 'HEIGHT') {
            property.tag = undefined
          }
          if (property.id === propertyId) {
            property.tag = 'HEIGHT'
            property.type = 'NUMBER'
          }
        })
      }
      this.onSelectAllChange(true)
    },
    isDisabled (item) {
      return !!item.tag
    },
    // async loadData () {
    //   this.tableLoading = true
    //   if (this.layerInfoData.layerId) {
    //     await this.getLayerData()
    //   }
    //   await this.getEnableTable()
    // },
    addTableEvent () {
      this.$nextTick(() => {
        const dom = this.$refs.multipleTable.bodyWrapper
        dom.addEventListener('scroll', () => {
          // 滚动距离
          const scrollTop = dom.scrollTop
          // 变量windowHeight是可视区的高度
          const windowHeight = dom.clientHeight
          // 变量scrollHeight是滚动条的总高度
          const scrollHeight = dom.scrollHeight
          // console.log('scrollTop：', scrollTop + 'windowHeight：', windowHeight + 'scrollHeight：', scrollHeight)
          if (scrollTop + windowHeight === scrollHeight) {
            // 滚动到底
            if (this.tablePageNumber < this.maxPageNumber - 1) {
              this.pageDown()
              dom.scrollTop = 1
            } else if (this.tablePageNumber === this.maxPageNumber - 1) {
              this.tablePageNumber = this.maxPageNumber - 1
              this.loadTablePage(this.tablePageNumber, this.tablePageNumber + 2)
            }
          } else if (scrollTop === 0) {
            if (this.tablePageNumber <= 1) {
              return
            }
            // 滚动到顶
            this.pageUp()
            if (this.tablePageNumber >= 1) {
              dom.scrollTop = scrollHeight - windowHeight - 1
            }
          }
        })
      })
    },
    getRowKey (row) {
      return row.uniqueId
    },
    // 清除数据
    clear () {
      this.markerList = []
      this.selectedData = []
      this.tableShowData = []
      this.maxCanSelect = 0
      // 选中ids
      this.selectedIds = {}
      // 是否选中所有
      this.isSelectedAll = true
      // 是否部分选中
      this.isIndeterminate = false
      this.$refs.gisHeader.resetFields()
      this.gisHeader = this.$options.data().gisHeader
    },
    onClose () {
      // this.clear()
      // this.isShow = false
      this.$emit('close')
    },
    // onBack () {
    //   this.onClose()
    // },
    // 获取图层属性
    // getLayerData () {
    //   getLayer({
    //     id: this.layerInfoData.layerId
    //   }).then(res => {
    //     if (res.code === 200) {
    //       this.layerInfoData.type = res.data.type
    //     }
    //   })
    // },
    // async getEnableTable () {
    //   try {
    //     const res = await getEnablTableData({
    //       layerId: this.layerInfoData.layerId,
    //       tableId: !this.layerInfoData || !this.layerInfoData.layerId ? this.tableId : undefined,
    //       pageNumber: 1,
    //       pageSize: 100000
    //     })
    //     if (res.code === 200) {
    //       this.tableHeader = res.data.properties
    //       // 新建图层初始化头
    //       if (!this.layerInfoData.layerId) {
    //         this.gisHeader = this.initGisHeader(res.data.properties)
    //       } else {
    //         this.gisHeader = this.getGisHeader(res.data.properties, res.data.coordinatesType)
    //       }

    //       this.tablesData = res.data.data.records
    //       this.coordType = res.data.coordinatesType
    //       // 只显示可以选择的数据
    //       const arr = []
    //       this.markerList.forEach((k) => {
    //         arr.push(k.uniqueId)
    //       })
    //       this.tablesData = this.tablesData.filter((item) => {
    //         return !arr.includes(item.uniqueId)
    //       })
    //       this.maxPageNumber = Math.ceil(this.tablesData.length / this.tablePageSize)
    //       this.tablePageNumber = 1
    //       this.loadTablePage(this.tablePageNumber, this.tablePageNumber + 1)
    //       // this.onSelectAllChange(!!this.gisHeader.namePropertyId && this.layerInfoData.type === 'POINT')
    //       this.onSelectAllChange(true)
    //     }
    //   } finally {
    //     this.tableLoading = false
    //   }
    // },
    pageUp () {
      this.tablePageNumber = this.tablePageNumber - 1
      if (this.tablePageNumber < 1) {
        this.tablePageNumber = 1
      }
      this.loadTablePage(this.tablePageNumber, this.tablePageNumber + 1)
    },
    pageDown () {
      this.tablePageNumber = this.tablePageNumber + 1
      if (this.tablePageNumber > this.maxPageNumber) {
        this.tablePageNumber = this.maxPageNumber
      }
      this.loadTablePage(this.tablePageNumber, this.tablePageNumber + 1)
    },
    loadTablePage (startPage, endPage) {
      const startIndex = this.tablePageSize * (startPage - 1)
      const endIndex = this.tablePageSize * (endPage - 1)
      this.tableShowData = []
      for (let i = startIndex; i < endIndex && i < this.importData.tablesData.dataList.length; i++) {
        this.tableShowData.push(this.importData.tablesData.dataList[i])
      }
      // 全选
      // this.$nextTick(() => {
      //   this.$refs.multipleTable.toggleAllSelection()
      // })
    },
    // 初始化表头
    // initGisHeader (header) {
    //   const tableProperties = []
    //   for (let i = 0; i < header.length; i++) {
    //     tableProperties.push({
    //       id: header[i].id,
    //       name: header[i].name,
    //       display: true,
    //       type: 'TEXT',
    //       tag: undefined
    //     })
    //   }
    //   return {
    //     lonHeader: undefined,
    //     latHeader: undefined,
    //     deviceId: undefined,
    //     namePropertyId: undefined,
    //     heightHeader: undefined,
    //     coordinatesType: 'NONE',
    //     tableProperties: tableProperties
    //   }
    // },
    // getGisHeader (header, coordinatesType) {
    //   let lonHeader
    //   let latHeader
    //   let namePropertyId
    //   let deviceId
    //   let heightHeader
    //   const tableProperties = []
    //   for (let i = 0; i < header.length; i++) {
    //     if (header[i].tag && header[i].tag.indexOf('LONGITUDE') >= 0) {
    //       lonHeader = header[i].id
    //     }
    //     if (header[i].tag && header[i].tag.indexOf('LATITUDE') >= 0) {
    //       latHeader = header[i].id
    //     }
    //     if (header[i].nameTag && header[i].nameTag.indexOf('MARK') >= 0) {
    //       namePropertyId = header[i].id
    //     }
    //     if (header[i].tag && header[i].tag.indexOf('HEIGHT') >= 0) {
    //       heightHeader = header[i].id
    //     }
    //     tableProperties.push(JSON.parse(JSON.stringify(header[i])))
    //   }
    //   return {
    //     lonHeader: lonHeader,
    //     latHeader: latHeader,
    //     namePropertyId: namePropertyId,
    //     deviceId: deviceId,
    //     heightHeader: heightHeader,
    //     coordinatesType: coordinatesType ?? 'NONE',
    //     tableProperties: tableProperties
    //   }
    // },
    // 数据是否有gis信息
    isHaveGis (data) {
      if (data[this.gisHeader.lonHeader] && data[this.gisHeader.latHeader]) {
        const lon = parseFloat(data[this.gisHeader.lonHeader])
        const lat = parseFloat(data[this.gisHeader.latHeader])
        return !isNaN(lon) && !isNaN(lat)
        // return true
      }
    },
    // 是否绑定了标注
    // isBindedMarker (data) {
    //   for (let i = 0; i < this.markerList.length; i++) {
    //     if (this.markerList[i].uniqueId === data.uniqueId) {
    //       return true
    //     }
    //   }
    //   return false
    // },
    canSelect (data, index) {
      // if (this.layerInfoData.type !== 'POINT') {
      //   return false
      // }
      if (!this.gisHeader.namePropertyId) {
        return false
      }
      if (!this.gisHeader.deviceId) {
        return false
      }
      if (!this.isHaveGis(data)) {
        return false
      }
      if (!data[this.gisHeader.namePropertyId]) {
        return false
      }
      if (!data[this.gisHeader.deviceId]) {
        return false
      }
      // if (this.isBindedMarker(data)) {
      //   return false
      // }
      return true
    },
    onHeaderChange (propertyId) {
      // this.gisHeader.tableProperties.forEach(property => {
      //   if (property.id === propertyId) {
      //     property.type = 'TEXT'
      //   }
      // })
      // 全选
      this.$nextTick(() => {
        // this.onSelectAllChange(this.layerInfoData.type === 'POINT')
        this.onSelectAllChange(true)
      })
    },
    // 勾选数据事件
    onTableSelectItem (selection, isSelected) {
      if (!this.canSelect(selection) && isSelected) {
        return
      }
      this.selectItem(selection, isSelected)
    },
    // 勾选所有事件
    onSelectAllChange (isSelected) {
      this.selectedData = []
      if (isSelected) {
        // 保存选中数据
        for (let i = 0; i < this.importData.tablesData.dataList.length; i++) {
          // const id = this.importData.tablesData.dataList[i][this.gisHeader.deviceId]
          const id = this.importData.tablesData.dataList[i].uniqueId
          if (this.canSelect(this.importData.tablesData.dataList[i])) {
            this.selectedData.push(this.importData.tablesData.dataList[i])
            this.$set(this.selectedIds, id, true)
          } else {
            this.$set(this.selectedIds, id, false)
          }
        }
        this.maxCanSelect = this.selectedData.length
      } else {
        for (let i = 0; i < this.importData.tablesData.dataList.length; i++) {
          // const id = this.importData.tablesData.dataList[i][this.gisHeader.deviceId]
          const id = this.importData.tablesData.dataList[i].uniqueId
          this.$set(this.selectedIds, id, false)
        }
      }
      this.isSelectedAll = this.selectedData.length > 0
      this.isIndeterminate = false
    },
    isSelectedItem (row) {
      const index = this.selectedData.findIndex((item) => {
        return item.uniqueId === row.uniqueId
      })
      return index >= 0
    },
    // 添加/移除选中数据
    selectItem (row, isSelected) {
      const index = this.selectedData.findIndex((item) => {
        return item.uniqueId === row.uniqueId
      })
      if (isSelected && index < 0) {
        this.selectedData.push(row)
      }
      if (!isSelected && index >= 0) {
        this.selectedData.splice(index, 1)
      }
      this.isIndeterminate = this.selectedData.length > 0 && this.maxCanSelect >= this.selectedData.length
    },
    // 提交绑定数据
    // async updateBindData () {
    //   const marks = []
    //   const selectedData = JSON.parse(JSON.stringify(this.selectedData))
    //   for (let i = 0; i < selectedData.length; i++) {
    //     // ids.push(selectedData[i].uniqueId)
    //     const name = selectedData[i][this.gisHeader.namePropertyId]
    //     if (this.coordType === 'BAIDU') {
    //       const lon = selectedData[i][this.gisHeader.lonHeader]
    //       const lat = selectedData[i][this.gisHeader.latHeader]
    //       let location = coordtransform.bd09togcj02(lon, lat)
    //       location = coordtransform.gcj02towgs84(location[0], location[1])
    //       selectedData[i][this.gisHeader.lonHeader] = location[0]
    //       selectedData[i][this.gisHeader.latHeader] = location[1]
    //     } else if (this.coordType === 'GAODE') {
    //       const lon = selectedData[i][this.gisHeader.lonHeader]
    //       const lat = selectedData[i][this.gisHeader.latHeader]
    //       const location = coordtransform.gcj02towgs84(lon, lat)
    //       selectedData[i][this.gisHeader.lonHeader] = location[0]
    //       selectedData[i][this.gisHeader.latHeader] = location[1]
    //     }
    //     const geoJson = GeoJSON.parse(selectedData[i], { Point: [this.gisHeader.latHeader, this.gisHeader.lonHeader] })
    //     geoJson.properties.draw_mode_ = CesiumPlus.DrawMode.Marker
    //     // 高度
    //     if (this.gisHeader.heightHeader) {
    //       let height = selectedData[i][this.gisHeader.heightHeader]
    //       height = isNaN(parseFloat(height)) ? 0 : parseFloat(height)
    //       geoJson.properties.height_ = JSON.stringify([height])
    //     }
    //     marks.push({
    //       geoJson: geoJson,
    //       uniqueId: selectedData[i].uniqueId,
    //       name: name
    //     })
    //   }
    //   // 有图层，绑定新数据
    //   if (this.layerInfoData.layerId) {
    //     if (marks.length > 0) {
    //       try {
    //         const res = await addDeviceMarkerBatch({
    //           layerId: this.layerInfoData.layerId,
    //           tableId: this.tableId,
    //           marks: marks
    //         })
    //         if (res.code === 200) {
    //           this.$Message('success', res.msg || '操作成功！')
    //           this.$emit('refresh')
    //         }
    //       } finally {
    //         this.loading = false
    //         this.onClose()
    //       }
    //     } else {
    //       this.$emit('refresh', false)
    //       this.loading = false
    //       this.onClose()
    //     }
    //   } else {
    //     try {
    //       const res = await addLayer({
    //         name: this.layerInfoData.name,
    //         mapId: this.layerInfoData.mapId,
    //         type: this.layerInfoData.type,
    //         groupId: this.layerInfoData.groupId,
    //         tableId: this.layerInfoData.tableId,
    //         namePropertyId: this.gisHeader.namePropertyId,
    //         coordinatesType: this.gisHeader.coordinatesType,
    //         properties: this.gisHeader.tableProperties,
    //         marks: marks
    //       })
    //       if (res.code === 200) {
    //         this.$Message('success', res.msg || '操作成功！')
    //         this.$emit('refresh')
    //       }
    //     } finally {
    //       this.loading = false
    //       this.onClose()
    //     }
    //   }
    // },
    // 更新图层属性
    // async updateProperty () {
    //   if (this.layerInfoData.layerId) {
    //     await updateLayerProperty({
    //       layerId: this.layerInfoData.layerId,
    //       properties: this.gisHeader.tableProperties
    //     })
    //   }
    // },
    async addMarkers () {
      this.loading = true
      const marks = []
      const selectedData = JSON.parse(JSON.stringify(this.selectedData))
      for (let i = 0; i < selectedData.length; i++) {
        // ids.push(selectedData[i].uniqueId)
        // const name = selectedData[i][this.gisHeader.namePropertyId]
        // const deviceId = selectedData[i][this.gisHeader.deviceId]
        const pointData = {
          name: selectedData[i][this.gisHeader.namePropertyId] || '',
          deviceId: selectedData[i][this.gisHeader.deviceId] || 0
        }
        if (this.coordType === 'BAIDU') {
          const lon = selectedData[i][this.gisHeader.lonHeader]
          const lat = selectedData[i][this.gisHeader.latHeader]
          let location = coordtransform.bd09togcj02(lon, lat)
          location = coordtransform.gcj02towgs84(location[0], location[1])
          pointData.lon = location[0]
          pointData.lat = location[1]
        } else if (this.coordType === 'GAODE') {
          const lon = selectedData[i][this.gisHeader.lonHeader]
          const lat = selectedData[i][this.gisHeader.latHeader]
          const location = coordtransform.gcj02towgs84(lon, lat)
          pointData.lon = location[0]
          pointData.lat = location[1]
        } else {
          const lon = selectedData[i][this.gisHeader.lonHeader]
          const lat = selectedData[i][this.gisHeader.latHeader]
          pointData.lon = lon
          pointData.lat = lat
        }
        const geoJson = GeoJSON.parse(pointData, { Point: ['lat', 'lon'] })
        geoJson.properties.draw_mode_ = CesiumPlus.DrawMode.Marker
        geoJson.properties.deviceId = pointData.deviceId
        // 高度
        if (this.gisHeader.heightHeader) {
          let height = selectedData[i][this.gisHeader.heightHeader]
          height = isNaN(parseFloat(height)) ? 0 : parseFloat(height)
          geoJson.properties.height_ = JSON.stringify([height])
        }
        marks.push({
          geoJson: geoJson,
          deviceId: pointData.deviceId,
          name: pointData.name
        })
      }
      if (marks.length > 0) {
        try {
          const res = await addDeviceMarkerBatch({
            layerId: this.importData.layerId,
            marks: marks
          })
          if (res.code === 200) {
            this.$Message('success', res.msg || '操作成功！')
            this.$emit('refresh')
          }
        } finally {
          this.loading = false
          this.onClose()
        }
      } else {
        this.$emit('refresh', false)
        this.loading = false
        this.onClose()
      }
    },
    async onSubmit () {
      // if (!this.layerInfoData.layerId) {
      //   await this.$refs.gisHeader.validate()
      // }
      // if (this.layerInfoData.layerId) {
      //   await this.updateProperty()
      // }
      // await this.updateBindData()
      await this.addMarkers()
    }
  },
  filters: {}
}
</script>

<style lang="scss">
  .importMarker{
    .el-dialog{
      width: 1360px;
      margin-top: 0px !important;
      top: 3vh;
      height: 880px;
    }
    .markerNameSelect{
      .el-input__inner{
        height: 32px !important;
      }
    }
    .title{
      font-size:16px;
    }
    .selectname{
      margin-left: 100px;
      color: #999999;
      margin-right: 20px;
    }
    .el-form-item__label {
      color: #999999;
    }
    .el-dialog__body{
      padding-bottom: 0;
      .table-box{
        min-height: 500px;
        height: 650px;
        .el-table {
          overflow: hidden !important;
        }
        .form{
          display: flex;
          align-items: center;
          justify-content: space-between;
          .el-form{
            width: 100%;
            display: flex;
            justify-content: space-between;
          }
        }
        .num{
          color: #999999;
        }
        .table-select{
          width: 100%;
        }
        .el-table .el-table__header-wrapper th{
          height: 50px !important;
        }
        .el-table{
          background-color: #272829;
          height: 95%;
          width: 80%;
          overflow: auto;
        }
        // .el-table__empty-block{
        //   background: #333333;
        // }
        .el-table__body-wrapper{
          height: calc(100% - 88px) !important;
        }
      }
    }
    .el-dialog__footer{
      position: relative;
      padding-top: 10px;
      .total{
        font-size: 14px;
        font-family: Source Han Sans SC;
        font-weight: 400;
        color: #999999;
        position: absolute;
        left: 20px;
        top: 20px;
        >span{
          color: white;
          font-size: 15px;
        }
      }
    }
    .dialog-footer{
      .bottom-left {
        float: left;
        .title{
          color: $font-color9;
        }
        .value{
          margin: 0px 10px;
          color: $font-colorf;
        }
      }
    }
  }
</style>

<style lang="scss" scoped>
.customDialog {
  box-sizing: border-box;
  display: flex;
  .table-header{
      display: flex;
      align-items: center;
      justify-content: space-between;
      text-align: left;
      &.el-form{
        width: 100%;
        display: flex;
        justify-content: space-between;
        .el-col-lg-4-8{
          width: 20%;
          text-align: right;
        }
        .el-form-item{
          margin-right: unset;
        }
        .el-select{
          width: 160px ;
        }
      }
    }
    .table-box{
      .head-attribute-name{
        color: #FFFFFF;
        svg{
          float: right;
          cursor: pointer;
          &:hover{
            color: $hover-color;
          }
        }
      }
    }
}
</style>
